import React, { type FC } from "react";
import { Spinner } from "@shared/ui/spinner/Spinner";
import type { BootstrapStep } from "./types";
import "./BootstrapScreen.scss";

export interface BootstrapScreenProps {
    currentStep: BootstrapStep | null;
}

/**
 * Лёгкий mobile UI загрузки bootstrap.
 */
export const BootstrapScreen: FC<BootstrapScreenProps> = ({ currentStep }) => (
    <div className="bootstrap_screen">
        <Spinner />
        <p className="bootstrap_screen__label">{currentStep?.label ?? "Подготовка приложения…"}</p>
    </div>
);
